/**
 * 页面文案词典 —— 中文（源语言）
 * 第四批：全站收尾（MyWebsite / WidgetPanel / Navigation / Permission / SiteConfig / Engine ...）
 */
export default {
  '操作失败': '操作失败',
  '成功': '成功',
  '删除失败': '删除失败',
  '网络错误': '网络错误',
  '保存失败': '保存失败',
  '其他': '其他',
  '制造业': '制造业',
  '医疗健康': '医疗健康',
  '合资': '合资',
  '启用': '启用',
  '国企': '国企',
  '外企': '外企',
  '失败': '失败',
  '房地产': '房地产',
  '教育培训': '教育培训',
  '正常': '正常',
  '民企': '民企',
  '物流运输': '物流运输',
  '电子商务': '电子商务',
  '软件开发': '软件开发',
  '金融业': '金融业',
  '上传失败': '上传失败',
  '中文名称': '中文名称',
  '分站状态': '分站状态',
  '守卫名称': '守卫名称',
  '已开启': '已开启',
  '开启分站': '开启分站',
  '普通': '普通',
  '未开启': '未开启',
  '未知': '未知',
  '添加绑定': '添加绑定',
  '禁用': '禁用',
  '绑定失败': '绑定失败',
  '绑定成功': '绑定成功',
  '编码': '编码',
  '翻译失败': '翻译失败',
  '行业': '行业',
  '行政代码': '行政代码',
  '解绑成功': '解绑成功',
  ' 条结构警告，请人工复核译文': ' 条结构警告，请人工复核译文',
  ' 段...': ' 段...',
  '// 请先选择企业': '// 请先选择企业',
  '上传成功': '上传成功',
  '主题描述': '主题描述',
  '主题标题': '主题标题',
  '产品中心': '产品中心',
  '企庭中国民营经济网': '企庭中国民营经济网',
  '分类名称': '分类名称',
  '分配权限': '分配权限',
  '创建失败': '创建失败',
  '刷新预览': '刷新预览',
  '发送失败': '发送失败',
  '在新窗口打开': '在新窗口打开',
  '复制失败，请手动选中复制': '复制失败，请手动选中复制',
  '媒体矩阵格子': '媒体矩阵格子',
  '已发布': '已发布',
  '已复制到剪贴板': '已复制到剪贴板',
  '已拒绝': '已拒绝',
  '已认证': '已认证',
  '所属城市': '所属城市',
  '所属导航': '所属导航',
  '所属省份': '所属省份',
  '打开首页': '打开首页',
  '批量导入链接': '批量导入链接',
  '抖音': '抖音',
  '排序 / 操作': '排序 / 操作',
  '新增权限': '新增权限',
  '新建': '新建',
  '新建企业账号': '新建企业账号',
  '新建分类': '新建分类',
  '新建违禁词': '新建违禁词',
  '日期筛选：': '日期筛选：',
  '更新失败': '更新失败',
  '未使用': '未使用',
  '标题 *': '标题 *',
  '标题必填': '标题必填',
  '正在翻译正文 第 ': '正在翻译正文 第 ',
  '添加格子': '添加格子',
  '登录失败': '登录失败',
  '确认导入': '确认导入',
  '第 ': '第 ',
  '编辑成功': '编辑成功',
  '编辑文章': '编辑文章',
  '翻译完成': '翻译完成',
  '翻译标题...': '翻译标题...',
  '草稿': '草稿',
  '获取权限列表失败': '获取权限列表失败',
  '角色名称': '角色名称',
  '解析链接': '解析链接',
  '该平台没有公开主页链接，建议改上传二维码': '该平台没有公开主页链接，建议改上传二维码',
  '请先选择企业': '请先选择企业',
  '请填写所有必填字段': '请填写所有必填字段',
  '请检查表单：格子标题不能为空': '请检查表单：格子标题不能为空',
  '请输入标题': '请输入标题',
  '请输入正确的URL格式': '请输入正确的URL格式',
  '近30天': '近30天',
  '返回列表': '返回列表',
  '返回首页': '返回首页',
  '还有 ': '还有 ',
  '违禁词': '违禁词',
  '顶级权限': '顶级权限',
  '首页轮播图': '首页轮播图',
  ' 段 <': ' 段 <',
  ' 段翻译失败，已保留原文：': ' 段翻译失败，已保留原文：',
  ')，请人工复核': ')，请人工复核',
  '/译文': '/译文',
  '2 列 grid2': '2 列 grid2',
  '3 列 grid3': '3 列 grid3',
  '4 列 grid4': '4 列 grid4',
  '> 标签数不一致(原文': '> 标签数不一致(原文',
  'AI 写作中...': 'AI 写作中...',
  'AI 正在翻译...': 'AI 正在翻译...',
  'AI 正在翻译中...': 'AI 正在翻译中...',
  'AI写作': 'AI写作',
  'AI文章': 'AI文章',
  'AI花费': 'AI花费',
  'Token消耗': 'Token消耗',
  'www.chpen.com 首页导航栏实时预览': 'www.chpen.com 首页导航栏实时预览',
  '⏳ AI 正在写作中...': '⏳ AI 正在写作中...',
  '一键填充九宫格': '一键填充九宫格',
  '上传封面图': '上传封面图',
  '上海企庭财务管理有限公司总经理，注册公司/代理记账/税务筹划/外贸结汇': '上海企庭财务管理有限公司总经理，注册公司/代理记账/税务筹划/外贸结汇',
  '不允许上传 SVG 图片': '不允许上传 SVG 图片',
  '丢弃': '丢弃',
  '中文正文': '中文正文',
  '主体': '主体',
  '九宫格条目（拖动顺序请用上移/下移）': '九宫格条目（拖动顺序请用上移/下移）',
  '二维码设置': '二维码设置',
  '产品介绍': '产品介绍',
  '企业': '企业',
  '企业入驻 · 新闻管理 · 资金清算': '企业入驻 · 新闻管理 · 资金清算',
  '企业全球 ID': '企业全球 ID',
  '企业列表加载中或为空': '企业列表加载中或为空',
  '企业列表加载失败，请刷新页面重试': '企业列表加载失败，请刷新页面重试',
  '企业宣传': '企业宣传',
  '企业宣传片': '企业宣传片',
  '企业把多个平台链接一次性贴进来，系统自动识别平台并生成格子': '企业把多个平台链接一次性贴进来，系统自动识别平台并生成格子',
  '企业类型': '企业类型',
  '企业：': '企业：',
  '企庭中国民营经济网创始人，深度 AI 实践者': '企庭中国民营经济网创始人，深度 AI 实践者',
  '企庭创始人 & CEO': '企庭创始人 & CEO',
  '使用时间': '使用时间',
  '保存修改': '保存修改',
  '保存后公开页面会即刻更新；上下线开关请联系平台管理员': '保存后公开页面会即刻更新；上下线开关请联系平台管理员',
  '保存失败，请稍后重试': '保存失败，请稍后重试',
  '保存失败：': '保存失败：',
  '保存并授权开通': '保存并授权开通',
  '信用代码': '信用代码',
  '停止': '停止',
  '充值日期': '充值日期',
  '充值金额': '充值金额',
  '全球 ID': '全球 ID',
  '全部文章': '全部文章',
  '公司名称': '公司名称',
  '关于我们': '关于我们',
  '关联地区': '关联地区',
  '关联权限数': '关联权限数',
  '关联用户数': '关联用户数',
  '关键词(逗号分隔)': '关键词(逗号分隔)',
  '关闭后公开页显示『已暂停展示』，配置保留': '关闭后公开页显示『已暂停展示』，配置保留',
  '其子菜单也会被删除。': '其子菜单也会被删除。',
  '内容预览': '内容预览',
  '写文章': '写文章',
  '准备翻译...': '准备翻译...',
  '创始人兼总经理 | 会计师': '创始人兼总经理 | 会计师',
  '创建': '创建',
  '创建成功，首页导航已同步': '创建成功，首页导航已同步',
  '删除成功，首页导航已同步': '删除成功，首页导航已同步',
  '删除配置': '删除配置',
  '加载企业信息失败': '加载企业信息失败',
  '加载失败，请稍后重试': '加载失败，请稍后重试',
  '加载失败：': '加载失败：',
  '加载导航数据失败': '加载导航数据失败',
  '加载导航选项失败': '加载导航选项失败',
  '加载网站配置失败': '加载网站配置失败',
  '动作': '动作',
  '区县名称': '区县名称',
  '即将上线': '即将上线',
  '友情链接设置': '友情链接设置',
  '发布成功': '发布成功',
  '发布状态': '发布状态',
  '发送中': '发送中',
  '发送方式': '发送方式',
  '发送时间': '发送时间',
  '发送验证码': '发送验证码',
  '受控动作总闸（白名单自愈动作）': '受控动作总闸（白名单自愈动作）',
  '变更前': '变更前',
  '变更后': '变更后',
  '可优化': '可优化',
  '可用': '可用',
  '启用中': '启用中',
  '启用但未展示': '启用但未展示',
  '吴琼': '吴琼',
  '告警收件邮箱': '告警收件邮箱',
  '告警通知总闸（邮件）': '告警通知总闸（邮件）',
  '固定高度版': '固定高度版',
  '图片上传失败': '图片上传失败',
  '图片上传失败: ': '图片上传失败: ',
  '图片上传成功': '图片上传成功',
  '图片大小不能超过20MB': '图片大小不能超过20MB',
  '城市名称': '城市名称',
  '基本信息': '基本信息',
  '填充到：': '填充到：',
  '子菜单': '子菜单',
  '子菜单分布：': '子菜单分布：',
  '学习层总闸（0=只算不写库）': '学习层总闸（0=只算不写库）',
  '官网首页': '官网首页',
  '实收充值（已收到款）': '实收充值（已收到款）',
  '审核备注（可选）': '审核备注（可选）',
  '密码登录': '密码登录',
  '导航菜单编辑（直接控制首页导航栏）': '导航菜单编辑（直接控制首页导航栏）',
  '已使用': '已使用',
  '已保存（即时生效）': '已保存（即时生效）',
  '已停止': '已停止',
  '已删除该企业的挂件配置': '已删除该企业的挂件配置',
  '已发布!': '已发布!',
  '已恢复本地草稿': '已恢复本地草稿',
  '已授权 · 公开页可见': '已授权 · 公开页可见',
  '已用抖音昵称 / 头像填充抖音格子，记得点保存': '已用抖音昵称 / 头像填充抖音格子，记得点保存',
  '已解绑': '已解绑',
  '已过期': '已过期',
  '已退出登录': '已退出登录',
  '已通过': '已通过',
  '平台授信': '平台授信',
  '年份': '年份',
  '开启后引擎将自动微调自身配置（有护栏+可回滚），确认？': '开启后引擎将自动微调自身配置（有护栏+可回滚），确认？',
  '当前余额': '当前余额',
  '当前账号权限已变更，正在刷新页面...': '当前账号权限已变更，正在刷新页面...',
  '当前钱包余额：': '当前钱包余额：',
  '微信联系': '微信联系',
  '快手号': '快手号',
  '总站（显示在首页导航栏）': '总站（显示在首页导航栏）',
  '总花费': '总花费',
  '恢复草稿': '恢复草稿',
  '成本(元)': '成本(元)',
  '所属企业': '所属企业',
  '所属行业': '所属行业',
  '所选条目没有可导入的图片或信息，请改选其他条目': '所选条目没有可导入的图片或信息，请改选其他条目',
  '所选条目都没有图片，轮播图需要图片，请改选其他条目': '所选条目都没有图片，轮播图需要图片，请改选其他条目',
  '手动写作': '手动写作',
  '手动重挖': '手动重挖',
  '批次翻译失败': '批次翻译失败',
  '批次翻译结果为空': '批次翻译结果为空',
  '把抖音 / 快手 / 小红书等平台链接一次性贴进来，系统自动识别平台并生成格子': '把抖音 / 快手 / 小红书等平台链接一次性贴进来，系统自动识别平台并生成格子',
  '把这段代码粘到你现有网站的页面里，展示的是紧凑九宫格形态（脚本用于 iframe 高度自适应）。': '把这段代码粘到你现有网站的页面里，展示的是紧凑九宫格形态（脚本用于 iframe 高度自适应）。',
  '抖音号': '抖音号',
  '抖音用户': '抖音用户',
  '抖音绑定失败，请重试': '抖音绑定失败，请重试',
  '抖音绑定成功': '抖音绑定成功',
  '挂件配置': '挂件配置',
  '挂件配置已保存': '挂件配置已保存',
  '授信': '授信',
  '排序(数字越小越靠前)': '排序(数字越小越靠前)',
  '排序失败': '排序失败',
  '排序已更新': '排序已更新',
  '探针': '探针',
  '提现审核_': '提现审核_',
  '支持直接粘贴抖音/小红书的分享口令（整段复制的文案），系统会自动识别里面的链接。\n例：\n【抖音】复制此条信息，打开抖音搜索我 https://v.douyin.com/xxxxx/\n12 小红书发布了一篇笔记，快来看吧 https://www.xiaohongshu.com/discovery/item/xxxx\nhttps://www.kuaishou.com/profile/xxxx\nhttps://www.example.com': '支持直接粘贴抖音/小红书的分享口令（整段复制的文案），系统会自动识别里面的链接。\n例：\n【抖音】复制此条信息，打开抖音搜索我 https://v.douyin.com/xxxxx/\n12 小红书发布了一篇笔记，快来看吧 https://www.xiaohongshu.com/discovery/item/xxxx\nhttps://www.kuaishou.com/profile/xxxx\nhttps://www.example.com',
  '支持直接粘贴抖音/小红书的分享口令（整段复制的文案），系统会自动识别里面的链接，并按平台归类。': '支持直接粘贴抖音/小红书的分享口令（整段复制的文案），系统会自动识别里面的链接，并按平台归类。',
  '故障持续重复提醒间隔（轮）': '故障持续重复提醒间隔（轮）',
  '敬请期待': '敬请期待',
  '数字人助理': '数字人助理',
  '文章标题': '文章标题',
  '新增企业': '新增企业',
  '新增区县': '新增区县',
  '新增城市': '新增城市',
  '新增导航': '新增导航',
  '新增省份': '新增省份',
  '新增管理员': '新增管理员',
  '新增顶级导航': '新增顶级导航',
  '新建SEO主题': '新建SEO主题',
  '新建主题': '新建主题',
  '新窗口看全站': '新窗口看全站',
  '新闻资讯': '新闻资讯',
  '无': '无',
  '日期筛选：近30天': '日期筛选：近30天',
  '是': '是',
  '是否菜单': '是否菜单',
  '普通用户': '普通用户',
  '暂无权限数据': '暂无权限数据',
  '暂未获取到抖音授权配置，请联系平台管理员开通': '暂未获取到抖音授权配置，请联系平台管理员开通',
  '更多数字人助理正在接入中，敬请期待': '更多数字人助理正在接入中，敬请期待',
  '更新': '更新',
  '更新成功': '更新成功',
  '更新成功，首页导航已同步': '更新成功，首页导航已同步',
  '最后活动': '最后活动',
  '最多 100 字': '最多 100 字',
  '最多 200 字': '最多 200 字',
  '最多 24 个格子': '最多 24 个格子',
  '最新': '最新',
  '月份': '月份',
  '未抓到公开信息，请手动补充标题 / 图片': '未抓到公开信息，请手动补充标题 / 图片',
  '未授权 · 公开页不展示': '未授权 · 公开页不展示',
  '未知错误': '未知错误',
  '未解析出任何可导入的条目': '未解析出任何可导入的条目',
  '权限分配失败': '权限分配失败',
  '权限名称': '权限名称',
  '标记': '标记',
  '模块': '模块',
  '模板类型': '模板类型',
  '正在上传图片...': '正在上传图片...',
  '每行粘贴一个链接，系统自动识别平台并生成格子。支持抖音 / 快手 / 小红书 / 官网等。': '每行粘贴一个链接，系统自动识别平台并生成格子。支持抖音 / 快手 / 小红书 / 官网等。',
  '没有匹配的企业': '没有匹配的企业',
  '法定代表人': '法定代表人',
  '注册账号总数': '注册账号总数',
  '注册资本': '注册资本',
  '浅色 light': '浅色 light',
  '浏览量': '浏览量',
  '深度分析': '深度分析',
  '深色 dark': '深色 dark',
  '添加产品': '添加产品',
  '添加友情链接': '添加友情链接',
  '添加成功': '添加成功',
  '添加轮播图': '添加轮播图',
  '点击开始对话': '点击开始对话',
  '热门': '热门',
  '生成中...': '生成中...',
  '生成失败': '生成失败',
  '生成完成': '生成完成',
  '生成耗时(秒)': '生成耗时(秒)',
  '用户ID': '用户ID',
  '用户类型': '用户类型',
  '用过聊天': '用过聊天',
  '电话咨询': '电话咨询',
  '登录失败，请检查返回': '登录失败，请检查返回',
  '登录已过期，请重新登录': '登录已过期，请重新登录',
  '省份名称': '省份名称',
  '短信价格(元)': '短信价格(元)',
  '短信登录': '短信登录',
  '短信花费': '短信花费',
  '确认提交?': '确认提交?',
  '禁用后不显示在首页': '禁用后不显示在首页',
  '移除': '移除',
  '简称': '简称',
  '管理员': '管理员',
  '管理端 vs 首页同步状态': '管理端 vs 首页同步状态',
  '管理端与首页数据完全一致': '管理端与首页数据完全一致',
  '管理端有但首页未展示': '管理端有但首页未展示',
  '级别': '级别',
  '纯授信（先给额度）': '纯授信（先给额度）',
  '绑定后自动同步抖音昵称与头像，无需手动填写。': '绑定后自动同步抖音昵称与头像，无需手动填写。',
  '结论': '结论',
  '缓存清理触发线（MB）': '缓存清理触发线（MB）',
  '编辑SEO主题': '编辑SEO主题',
  '编辑企业账号': '编辑企业账号',
  '编辑企业：': '编辑企业：',
  '编辑分类': '编辑分类',
  '编辑区县': '编辑区县',
  '编辑城市': '编辑城市',
  '编辑权限': '编辑权限',
  '编辑省份': '编辑省份',
  '编辑违禁词': '编辑违禁词',
  '缺少企业ID': '缺少企业ID',
  '网站主题色': '网站主题色',
  '置信度': '置信度',
  '翻译中...': '翻译中...',
  '翻译结果为空': '翻译结果为空',
  '翻译结果为空，请手动填写': '翻译结果为空，请手动填写',
  '翻译请求失败: HTTP ': '翻译请求失败: HTTP ',
  '耗时(ms)': '耗时(ms)',
  '联系我们': '联系我们',
  '联系电话': '联系电话',
  '自动保存已开启（本地草稿）': '自动保存已开启（本地草稿）',
  '自动翻译为英文': '自动翻译为英文',
  '自检周期（秒，下限30）': '自检周期（秒，下限30）',
  '自适应档位': '自适应档位',
  '自适应高度版（推荐）': '自适应高度版（推荐）',
  '英文标题': '英文标题',
  '英文标题不能超过255字符（数据库上限）': '英文标题不能超过255字符（数据库上限）',
  '草稿已保存': '草稿已保存',
  '草稿箱': '草稿箱',
  '获取角色列表失败': '获取角色列表失败',
  '行业报告': '行业报告',
  '规则': '规则',
  '规则重挖完成': '规则重挖完成',
  '解析失败，请稍后重试': '解析失败，请稍后重试',
  '解绑失败，请稍后重试': '解绑失败，请稍后重试',
  '触发': '触发',
  '证据': '证据',
  '该平台未开放对外接口，请在下方媒体矩阵中手动填写并上传二维码/封面': '该平台未开放对外接口，请在下方媒体矩阵中手动填写并上传二维码/封面',
  '请上传网站Logo': '请上传网站Logo',
  '请先输入中文标题和正文内容': '请先输入中文标题和正文内容',
  '请求失败': '请求失败',
  '请求方法': '请求方法',
  '请确认信息已正确填写后再提交。': '请确认信息已正确填写后再提交。',
  '请联系平台管理员开通': '请联系平台管理员开通',
  '请联系平台管理员开通抖音授权': '请联系平台管理员开通抖音授权',
  '请输入URI': '请输入URI',
  '请输入企业名称': '请输入企业名称',
  '请输入内容': '请输入内容',
  '请输入写作要求': '请输入写作要求',
  '请输入分类名称': '请输入分类名称',
  '请输入导航名称': '请输入导航名称',
  '请输入文章正文内容...': '请输入文章正文内容...',
  '请输入权限名称': '请输入权限名称',
  '请输入模块': '请输入模块',
  '请输入正确的手机号': '请输入正确的手机号',
  '请输入正确的邮箱格式': '请输入正确的邮箱格式',
  '请输入正确的链接地址格式': '请输入正确的链接地址格式',
  '请输入版权名称': '请输入版权名称',
  '请输入版权链接': '请输入版权链接',
  '请输入简称': '请输入简称',
  '请输入管理后台地址': '请输入管理后台地址',
  '请输入网站描述': '请输入网站描述',
  '请输入网站标题': '请输入网站标题',
  '请输入联系地址': '请输入联系地址',
  '请输入联系电话': '请输入联系电话',
  '请输入联系邮箱': '请输入联系邮箱',
  '请输入英文名称': '请输入英文名称',
  '请输入英文版权名称': '请输入英文版权名称',
  '请输入英文网站描述': '请输入英文网站描述',
  '请输入英文联系地址': '请输入英文联系地址',
  '请输入角色名称': '请输入角色名称',
  '请输入链接名称': '请输入链接名称',
  '请输入链接地址': '请输入链接地址',
  '请选择上级权限': '请选择上级权限',
  '请选择分类': '请选择分类',
  '请选择守卫名称': '请选择守卫名称',
  '请选择所属导航': '请选择所属导航',
  '请选择是否菜单': '请选择是否菜单',
  '请选择状态': '请选择状态',
  '请选择请求方法': '请选择请求方法',
  '账单明细_': '账单明细_',
  '账号名称': '账号名称',
  '超级管理员': '超级管理员',
  '轮播': '轮播',
  '近 30 天活跃': '近 30 天活跃',
  '这个地址就是你的企业官网，可直接对外发布，也可绑定你自己的一级域名（联系平台管理员）。': '这个地址就是你的企业官网，可直接对外发布，也可绑定你自己的一级域名（联系平台管理员）。',
  '这里填的联系方式会覆盖企业档案里的默认值，只展示在本官网上。': '这里填的联系方式会覆盖企业档案里的默认值，只展示在本官网上。',
  '连续失败告警阈值（轮）': '连续失败告警阈值（轮）',
  '迭代闭环总闸（自改配置，带护栏）': '迭代闭环总闸（自改配置，带护栏）',
  '选择一位数字人助理开始对话，更多助理将陆续接入': '选择一位数字人助理开始对话，更多助理将陆续接入',
  '选择企业后自动生成': '选择企业后自动生成',
  '通过提现': '通过提现',
  '邮箱': '邮箱',
  '邮箱格式不正确': '邮箱格式不正确',
  '邮箱联系': '邮箱联系',
  '部分图片占位符未还原，请检查译文中的图片是否完整': '部分图片占位符未还原，请检查译文中的图片是否完整',
  '配置列表加载失败，请刷新页面重试': '配置列表加载失败，请刷新页面重试',
  '重挖失败：': '重挖失败：',
  '重新上传': '重新上传',
  '重新加载': '重新加载',
  '重新自检': '重新自检',
  '金额（元）': '金额（元）',
  '金额：': '金额：',
  '钱包充值_': '钱包充值_',
  '链接地址（留空则移除链接）': '链接地址（留空则移除链接）',
  '链接已复制': '链接已复制',
  '陈少华': '陈少华',
  '需要标题和内容': '需要标题和内容',
  '页脚': '页脚',
  '预览可能需要几十秒刷新，如未更新请点刷新': '预览可能需要几十秒刷新，如未更新请点刷新',
  '首页实时预览': '首页实时预览',
  '首页导航栏预览（实时同步 www.chpen.com）': '首页导航栏预览（实时同步 www.chpen.com）',
  '首页导航编辑': '首页导航编辑',
  '首页展示中': '首页展示中',
  '首页有但管理端缺失': '首页有但管理端缺失',
  '首页横幅（Hero）': '首页横幅（Hero）',
  '验证码已发送': '验证码已发送',
  '（未开通）': '（未开通）',
  '💾 保存草稿': '💾 保存草稿',
  '📋 复制内容': '📋 复制内容',
  '📝 草稿箱': '📝 草稿箱',
  '🔄 翻译中英': '🔄 翻译中英',
  '🔄 自动翻译中英': '🔄 自动翻译中英',
  '🚀 一键生成': '🚀 一键生成',
  '🚀 发布文章': '🚀 发布文章',
};
